<template>
  <a-modal v-model:visible="visibleInfo" title="基本信息" :confirm-loading="confirmLoadingInfo" :destroyOnClose="true"
    :maskClosable="false" :okText="'保存'" @cancel="handleCancel('info')" @ok="handleOk('info')">
    <a-form ref="formRefInfo" :model="formInfo" :label-col="{ span: 6 }" autocomplete="off" :rules="rules">
      <!-- 上传头像 -->
      <a-form-item label="上传头像：" name="head_image">
        <a-upload v-model:file-list="fileList" accept=".png,.jpg" list-type="picture-card" :max-count="1"
          :customRequest="customRequest">
          <div>
            <div class="ant-upload-text">Upload</div>
          </div>
        </a-upload>

      </a-form-item>

      <a-form-item label="姓名：" name="fullname">
        <a-input v-model:value="formInfo.fullname" />
      </a-form-item>
      <a-form-item label="邮箱：" name="email">
        <a-input v-model:value="formInfo.email" disabled />
      </a-form-item>
      <a-form-item label="手机号：" name="tel">
        <a-input v-model:value="formInfo.tel" />
      </a-form-item>
      <a-form-item label="单位(开票单位)：" name="company_invoice">
        <div style="display: flex; align-items: center;">
          <a-input v-model:value="formInfo.company_invoice" :disabled="noCompany" style="flex: 1;"/>
          <a-checkbox v-model:checked="noCompany" style="margin-left: 10px;white-space: nowrap;" @change="handleNoCompanyChange">
            个人
          </a-checkbox>
        </div>
      </a-form-item>
      <a-form-item label="课题组/负责人：" name="piname">
        <div style="display: flex; align-items: center;">
          <a-input v-model:value="formInfo.piname" :disabled="noTeam" style="flex: 1;"/>
          <a-checkbox v-model:checked="noTeam" style="margin-left: 10px;white-space: nowrap;" @change="handleNoTeamChange">
            无课题组
          </a-checkbox>
        </div>

      </a-form-item>

      <!-- 
      <a-form-item label="税率：" name="FTaxRate">
        <a-select v-model:value="formInfo.FTaxRate">
          <a-select-option value="SL07_SYS">3%</a-select-option>
          <a-select-option value="SL06_SYS">6%</a-select-option>
          <a-select-option value="SL02_SYS">13%</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="发票类型：" name="FInvoiceType">
        <a-radio-group v-model:value="formInfo.FInvoiceType">
          <a-radio :value="'1'">增值税专用发票</a-radio>
          <a-radio :value="'2'">普通发票</a-radio>
        </a-radio-group>
      </a-form-item> -->
      <a-form-item label="单位名称：" name="company">
        {{ formInfo.company
        }}<span class="link_color" @click="visibleCompany = true">修改</span>
      </a-form-item>
      <a-form-item label="客户id：" name="k3_code">
        {{ formInfo.k3_code }}
      </a-form-item>

      <!-- <a-form-item label="默认：">
        <a-checkbox :checked="true" :disabled="true"></a-checkbox>
      </a-form-item> -->
    </a-form>
  </a-modal>
  <!-- 修改单位 -->
  <a-modal v-model:visible="visibleCompany" title="更改单位" :confirm-loading="confirmLoadingCompany" :destroyOnClose="true"
    :maskClosable="false" @cancel="handleCancel('company')" @ok="handleOk('company')">
    <a-form ref="formRefCompany" :model="formCompany" :label-col="{ span: 4 }" autocomplete="off">
      <a-form-item label="" name="status">
        <a-radio-group v-model:value="formCompany.status">
          <a-radio :value="1">单位名称更名或错误</a-radio>
          <a-radio :value="2">换工作单位</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="" v-if="formCompany.status === 2">
        换工作单位的情况下，请重新申请账户
      </a-form-item>
      <a-form-item label="单位名称：" name="company" :rules="[{ required: true, message: '请输入单位名称' }]"
        v-if="formCompany.status === 1">
        <a-input v-model:value="formCompany.company" />
      </a-form-item>
      <a-form-item label="" name="business_license" v-if="formCompany.status === 1">
        <div>
          <p style="padding-bottom: 10px">请上传营业执照或者更名证明</p>
          <upload :maxCount="1" @upload-success="uploadSuccess" :beforeUpload="beforeUploadFile"
            :accept="'.jpg,.pdf,.png,.gif,.jpeg'" :tipText="'支持jpg、pdf、png、gif、jpeg,不能超过5M'"></upload>
        </div>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script lang="ts">
import { editUserInfo, getUserInfo, uploadAvatar } from "@/api/api";
import { FormInstance, message, Modal } from "ant-design-vue";
import { defineComponent, reactive, ref, toRefs ,watch} from "vue";
import { useStore } from "vuex";
import Upload from "@/components/upload/index.vue";
import { computed } from 'vue';

import { phoneValidate } from '@/utils/tool'
import { Rule } from "ant-design-vue/lib/form";
import { SET_USERINFO } from "@/store/types";
import defaultAvatar from '@/assets/images/avatar.png'
interface FormInfo {
  head_image: string,
  company: string;
  k3_code: string;
  FShippingAddress: string;
  FShippingPerson: string;
  FShippingPhoneNo: string;
  fullname: string;
  tel: string;
  piname: string;
  company_invoice: string;
  FTaxRate: string;
  email: string;
  FInvoiceType?: number;
}
type FormCompany = {
  company: string;
  status: number;
  business_license: string;
};
interface Date {
  formInfo: FormInfo;
  confirmLoadingInfo: boolean;
  visibleInfo: boolean;
  visibleCompany: boolean;
  confirmLoadingCompany: boolean;
  formCompany: FormCompany;
}
export default defineComponent({
  components: {
    Upload,
  },
  
  setup() {
    const store = useStore();
    const formRefInfo = ref<FormInstance>();
    const formRefCompany = ref<FormInstance>();
    const fileList = ref<any>([{
      uid: '-1', // 固定值表示已有图片
      name: 'avatar.png',
      status: 'done',
      url: store.state.userInfo.head_image || defaultAvatar
    }]);
    const url = ref<string>(
      `${process.env.VUE_APP_API_URL}/api/home/upload_file/`
    );
    const headers = ref({
      'SESSION-ID': store.getters.getToken,
    });
    const noCompany = ref(false)
    const noTeam = ref(false)
    const formData = reactive<Date>({
      formInfo: {
        head_image: store.state.userInfo.head_image,
        company: store.state.userInfo.company,
        k3_code: store.state.userInfo.k3_code,
        FShippingAddress:
          store.state.userInfo.k3_customer_data.FShippingAddress,
        FShippingPerson: store.state.userInfo.k3_customer_data.FShippingPerson,
        FShippingPhoneNo:
          store.state.userInfo.k3_customer_data.FShippingPhoneNo,
        fullname: store.state.userInfo.fullname,
        tel: store.state.userInfo.tel,
        piname: store.state.userInfo.piname,
        company_invoice: store.state.userInfo.company_invoice,
        FTaxRate: store.state.userInfo.FTaxRate,
        email: store.state.userInfo.email,
        FInvoiceType: store.state.userInfo.FInvoiceType,
      },
      confirmLoadingInfo: false,
      visibleInfo: false,
      visibleCompany: false,
      confirmLoadingCompany: false,
      formCompany: {
        company: "",
        status: 1,
        business_license: "",
      },
    });
    const rules: Record<string, Rule[]> = {
      fullname: [{ required: true, message: '请输入姓名' }],
      email: [{ required: true, message: '请输入邮箱' }],
      tel: [{ required: true, validator: phoneValidate }],
      piname: [{ required: true, message: '请输入负责人' }],
      company_invoice: [{ required: true, message: '请输入单位' }],
      FTaxRate: [{ required: true, message: '请选择税率' }],
      FInvoiceType: [{ required: true, message: '请选择发票类型' }],
    };
    const handleNoCompanyChange = () => {
      if (noCompany.value) {
        formData.formInfo.company_invoice = '个人'
      }else{
        formData.formInfo.company_invoice = ''
      }
    }
    const handleNoTeamChange = (val: boolean) => {
      if (val) {
        formData.formInfo.piname = formData.formInfo.fullname
      }
    }
    // 点击弹窗确定
    function handleOk(type?: string) {
      if (type === "info") {
        // 修改个人资料
        formRefInfo.value?.validate().then(() => {
          formData.confirmLoadingInfo = true;
          editUserInfo({
            fullname: formData.formInfo.fullname,
            email: formData.formInfo.email,
            username: formData.formInfo.email,
            tel: formData.formInfo.tel,
            piname: formData.formInfo.piname,
            company_invoice: formData.formInfo.company_invoice,
            FTaxRate: formData.formInfo.FTaxRate,
            FInvoiceType: formData.formInfo.FInvoiceType,
            head_image: formData.formInfo.head_image
          }).then(() => {
            message.success('修改成功')
            getUserInfo().then((res) => {
              console.log(123)
              store.commit(SET_USERINFO, res)
              formData.formInfo = res as any
            })
            formData.confirmLoadingInfo = false;
            handleCancel('info')
          })
            .catch(() => {
              formData.confirmLoadingInfo = false;
            });
        });
        return;
      }
      // 换工作单位无任何操作
      if (formData.formCompany.status === 2) {
        handleCancel('company')
        return;
      }
      formRefCompany.value?.validate().then(() => {
        // data.confirmLoadingInfo = true;
        const params = {
          company: "",
          business_license: "",
          status: 3, // 只要修改单位就需要申请关联k3
        };
        params.company = formData.formCompany.company;
        params.business_license = formData.formCompany.business_license;
        formData.confirmLoadingCompany = true;
        editUserInfo(params)
          .then(() => {
            Modal.success({
              title: "提交成功",
              content: "请求已提交，将在24小时内处理，请及时关注。",
              closable: true,
              onOk() {
                formData.confirmLoadingCompany = false;
                handleCancel('company')
              },
            });
          })
          .catch(() => {
            formData.confirmLoadingCompany = false;
          });
      });
    }
    // 弹框关闭
    function handleCancel(type?: string) {
      if (type === "info") {
        formRefInfo.value?.resetFields();
        formData.visibleInfo = false;
        return;
      }
      formRefCompany.value?.resetFields();
      formData.visibleCompany = false;
    }
    // 
    function beforeUploadFile(file: any) {
      const isLT5M = file.size / 1024 / 1024 < 5
      if (!isLT5M) {
        message.warning('文件大小不能超过5M')
        return false
      }
      return true
    }
    // 上传成功
    function uploadSuccess(fileList: any[]) {
      if (fileList.length !== 0) {
        formData.formCompany.business_license = fileList[0].file_path;
        formRefCompany.value?.clearValidate(["business_license"]);
      } else {
        formData.formCompany.business_license = "";
      }
    }
    function customRequest(options: any) {
      const { file, onSuccess, onError } = options; // 解构必要回调

      const temp = new FormData();
      temp.append('file', file);
      uploadAvatar(temp).then((res: any) => {
        formData.formInfo.head_image = res?.relative_path || ''
        onSuccess(res, file);
        fileList.value = [{
          uid: file.uid,
          name: file.name,
          status: 'done', // 必须设置为 'done'
          url: res?.relative_path || '',
        }];
      })
    }
    watch(
      () => formData.visibleInfo,
      (val) => {
        if (val) {
          noCompany.value = false
          noTeam.value = false
          Object.assign(formData.formInfo, {
            head_image: store.state.userInfo.head_image,
            company: store.state.userInfo.company,
            k3_code: store.state.userInfo.k3_code,
            FShippingAddress:
              store.state.userInfo.k3_customer_data.FShippingAddress,
            FShippingPerson: store.state.userInfo.k3_customer_data.FShippingPerson,
            FShippingPhoneNo:
              store.state.userInfo.k3_customer_data.FShippingPhoneNo,
            fullname: store.state.userInfo.fullname,
            tel: store.state.userInfo.tel,
            piname: store.state.userInfo.piname,
            company_invoice: store.state.userInfo.company_invoice,
            FTaxRate: store.state.userInfo.FTaxRate,
            email: store.state.userInfo.email,
            FInvoiceType: store.state.userInfo.FInvoiceType,
          });
        }
      });
    return {
      url,
      fileList,
      headers,
      noCompany,
      noTeam,
      formRefInfo,
      formRefCompany,
      rules,
      ...toRefs(formData),
      handleCancel,
      handleOk,
      handleNoCompanyChange,
      handleNoTeamChange,
      uploadSuccess,
      beforeUploadFile,
      customRequest
    };
  },
   
});
</script>
<style lang="stylus" scoped></style>